import $ from 'jquery';
import _ from 'underscore';

import 'Lib/jquery.onMutate';

console.log('init page.store-locator');

$('.page-tab-link').on('click', function (event) {
  console.log(event);
  $('.page-tab.show').removeClass('show');
  $('.page-tab-link.active').removeClass('active');

  $(event.currentTarget).addClass('active');
  var idToShow = event.currentTarget.id.replace('link-', '');
  console.log(idToShow);
  $('#' + idToShow).addClass('show');
});

$('#page-tab-store-locator').onCreate('.stockist-search-form', function (el) {
  el.detach().appendTo('.page-tab-links');
})
